import { render, staticRenderFns } from "./zaijian.vue?vue&type=template&id=532b6b48&"
import script from "./zaijian.vue?vue&type=script&lang=js&"
export * from "./zaijian.vue?vue&type=script&lang=js&"
import style0 from "./zaijian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports